"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceModelType = exports.DeviceModelId = exports.BrandId = exports.BrandType = void 0;
var BrandType;
(function (BrandType) {
    BrandType["ELSYS"] = "ELSYS";
    BrandType["EURECAM"] = "EURECAM";
    BrandType["HIKVISION"] = "HIKVISION";
    BrandType["NANOSENSE"] = "NANOSENSE";
    BrandType["NEXELEC"] = "NEXELEC";
    BrandType["RUBIX"] = "RUBIX";
    BrandType["TERABEE"] = "TERABEE";
    BrandType["TECHNIS"] = "TECHNIS";
    BrandType["TESTO"] = "TESTO";
    BrandType["VCOUNT"] = "VCOUNT";
    BrandType["XOVIS"] = "XOVIS";
})(BrandType = exports.BrandType || (exports.BrandType = {}));
var BrandId;
(function (BrandId) {
    BrandId[BrandId["ELSYS"] = 4] = "ELSYS";
    BrandId[BrandId["EURECAM"] = 7] = "EURECAM";
    BrandId[BrandId["HIKVISION"] = 1] = "HIKVISION";
    BrandId[BrandId["NANOSENSE"] = 5] = "NANOSENSE";
    BrandId[BrandId["NEXELEC"] = 10] = "NEXELEC";
    BrandId[BrandId["RUBIX"] = 9] = "RUBIX";
    BrandId[BrandId["TERABEE"] = 2] = "TERABEE";
    BrandId[BrandId["TECHNIS"] = 11] = "TECHNIS";
    BrandId[BrandId["TESTO"] = 3] = "TESTO";
    BrandId[BrandId["VCOUNT"] = 6] = "VCOUNT";
    BrandId[BrandId["XOVIS"] = 8] = "XOVIS";
})(BrandId = exports.BrandId || (exports.BrandId = {}));
exports.DeviceModelId = {
    ELSYS_ERSCO2: 7,
    NANOSENSE_E4000NG: 9,
    RUBIX_POD2: 18,
    TESTO_160IAQ: 6,
};
exports.DeviceModelType = (_a = {},
    _a[BrandId.ELSYS] = [exports.DeviceModelId.ELSYS_ERSCO2, 8],
    _a[BrandId.EURECAM] = [11],
    _a[BrandId.HIKVISION] = [1, 2, 3, 4],
    _a[BrandId.NANOSENSE] = [exports.DeviceModelId.NANOSENSE_E4000NG],
    _a[BrandId.NEXELEC] = [20, 19, 21],
    _a[BrandId.RUBIX] = [18],
    _a[BrandId.TERABEE] = [5, 25],
    _a[BrandId.TECHNIS] = [22, 23, 24],
    _a[BrandId.TESTO] = [exports.DeviceModelId.TESTO_160IAQ],
    _a[BrandId.VCOUNT] = [10],
    _a[BrandId.XOVIS] = [12, 13, 14, 15, 16, 17, 26, 27],
    _a);
